import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import Button from "@material-ui/core/Button";
import React from "react";
import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

am4core.useTheme(am4themes_animated);

const communityColor = "#e34040";
const systemViewerColor = "#1b8b1b";
const webPortalColor = "#20209c";

class LogScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, events: [], page: 0};
    }

    makeChart = (target) => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(target, am4charts.XYChart);

        chart.paddingRight = 20;
        chart.colors.list = [
            am4core.color(communityColor),
            am4core.color(systemViewerColor),
            am4core.color(webPortalColor)
        ];

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        dateAxis.dateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("month", "MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("month", "MMM yyyy");

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "community";
        series.name = "Community Viewer";
        series.tooltipText = "{valueY.value} community app loads";

        let series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.dateX = "date";
        series2.dataFields.valueY = "system";
        series2.name = "System Viewer";
        series2.tooltipText = "{valueY.value} system viewer loads";

        let series3 = chart.series.push(new am4charts.LineSeries());
        series3.dataFields.dateX = "date";
        series3.dataFields.valueY = "web";
        series3.name = "Web Portal";
        series3.tooltipText = "{valueY.value} web portal loads";

        chart.cursor = new am4charts.XYCursor();

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        scrollbarX.series.push(series2);
        scrollbarX.series.push(series3);
        chart.scrollbarX = scrollbarX;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "App Usage";
        chart.legend = new am4charts.Legend();

        return chart;
    };

    makeChart2 = (target) => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(target, am4charts.XYChart);

        chart.paddingRight = 20;
        chart.colors.list = [
            am4core.color(communityColor),
            am4core.color(systemViewerColor),
            am4core.color(webPortalColor)
        ];

        let dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.dataFields.category = "name";
        dateAxis.renderer.labels.template.hidden = true;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "name";
        series.dataFields.valueY = "community";
        series.name = "Community Viewer";
        series.tooltipText = "{valueY.value} views on community app";
        series.stacked = true;

        let series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.categoryX = "name";
        series2.dataFields.valueY = "system";
        series2.name = "System Viewer";
        series2.tooltipText = "{valueY.value} views on system viewer app";
        series2.stacked = true;

        let series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.dataFields.categoryX = "name";
        series3.dataFields.valueY = "web";
        series3.name = "Web Portal";
        series3.tooltipText = "{valueY.value} views on web portal";
        series3.stacked = true;

        chart.cursor = new am4charts.XYCursor();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "App Usage";
        chart.legend = new am4charts.Legend();

        return chart;
    };


    componentDidMount() {
        this.chart = this.makeChart("chartdiv");
        this.chart2 = this.makeChart2("chartdiv2");

        API.POST("log/getUsageData", {}, result => {
            if (result.success) {
                this.setState(result.result, this.setupGraph);
            }
        });
        API.POST("log/getUsageDataByCamera", {}, result => {
            if (result.success) {
                this.setState(result.result, this.setupGraph2);
            }
        });
        this.fetch();
    }

    fetch = () => {
        this.setState({loaded: false});
        API.POST("log/list", {page: this.state.page}, result => {
            Util.handleLogout(result);
            if (result.success) {
                let events = this.state.events.concat(result.result.events);
                this.setState({events});
                this.setState({loaded: true});
            }
        });
    };

    setupGraph = () => {
        let data = [];
        this.state.graph_data.forEach(datum => {
            data.push({
                date: new Date(datum.time * 1000),
                name: "",
                community: datum.community,
                system: datum.system,
                web: datum.web
            });
        });
        this.chart.data = data;
    };

    setupGraph2 = () => {
        let data = [];
        this.state.graph_data_by_cam.forEach(datum => {
            data.push({
                camera_id: datum.camera_id,
                name: datum.name,
                community: datum.community,
                system: datum.system,
                web: datum.web,
                total: datum.total
            });
        });
        data = data.sort((b, a) => Util.compare(a.total, b.total));
        data = data.slice(0, 20);
        this.chart2.data = data;
    };

    render() {
        return (
            <div>
                <ActionBar title="Usage and Logs"/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16
                }}>
                    <div style={{flex: 1}}>
                        <h1>App Usage</h1>
                        <div id="chartdiv" style={{height: "calc(50vh - 85px)"}}/>
                        <h3>Top 20 in 24 hours:</h3>
                        <div id="chartdiv2" style={{height: "calc(50vh - 120px)"}}/>
                    </div>
                    <div style={{flex: 1, maxHeight: "calc(100vh - 100px)", overflowY: "auto"}}>
                        <h1>System Log</h1>
                        {this.renderLog()}
                    </div>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    loadMore = () => {
        this.setState({page: this.state.page + 1}, this.fetch);
    };

    renderLog = () => {
        let styleTd = {
            padding: 8
        };
        return (
            <table style={{width: "100%"}}>
                <thead>
                <tr style={{background: "#EEE"}}>
                    <th>User</th>
                    <th style={styleTd}>Event</th>
                    <th style={styleTd}>Timestamp</th>
                </tr>
                </thead>
                <tbody>
                {this.state.events.map(this.renderEvent)}
                <tr>
                    <Button variant="contained" color="primary" className="vl-button wide top8" onClick={this.loadMore}>Load
                        More</Button>
                </tr>
                </tbody>
            </table>
        );
    };

    renderEvent = (event) => {
        let styleTd = {
            padding: 8
        };
        return (
            <tr style={{background: event.colour}}>
                <td style={styleTd}>{event.user_name}</td>
                <td style={styleTd}>{event.text}</td>
                <td style={styleTd}>{event.date}</td>
            </tr>);
    };

}

export default LogScreen;
